<script>
import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import {
  getFirestore,
  collection,
  updateDoc,
  serverTimestamp,
  doc,
} from 'firebase/firestore/lite'
import { firebase } from '../../../../../firebase-int'
import CryptoJS from 'crypto-js'

const firestore = getFirestore(firebase)
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from 'vuelidate/lib/validators'

export default {
  page: {
    title: 'Edit Member',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertMessage: '',
      successStatus: true,
      processingData: false,

      pvtData: '',
      secret: '123#$%',
      encData: '',

      title: 'Edit Member',
      items: [
        {
          text: 'Gebi',
          href: '/',
        },
        {
          text: 'Member',
          href: '/Member',
        },
        {
          text: 'Edit Member: ' + this.$route.params.member.id,
          active: true,
        },
      ],
      sex: ['Female', 'Male'],
      employer: [],
      region: [],
      accessLevel: [],
      status: [],
      sexValue: this.$route.params.member.sex,
      dobValue: this.$route.params.member.dob,
      employerValue: this.$route.params.member.employerId,
      regionValue: this.$route.params.member.region,
      statusValue: this.$route.params.member.status,
      //employerId:this.$route.params.member.employerId,
      accessLevelValue: this.$route.params.member.accessLevel,

      federationsNameList: [],
      federationsIdList: [],
      unionsNameList: [],
      unionsIdList: [],

      adminFederation:this.$route.params.member.adminFederation,
      adminUnion:this.$route.params.member.adminUnion,
      adminFederationName:null,
      adminUnionName:null,


      form: {
        firstName: this.$route.params.member.firstName,
        fatherName: this.$route.params.member.fatherName,
        grandFatherName: this.$route.params.member.grandFatherName,
        email: this.$route.params.member.email,
        zoneSubcity: this.$route.params.member.zoneSubcity,
        woreda: this.$route.params.member.woreda,
        kebele: this.$route.params.member.kebele,
        houseNumber: this.$route.params.member.houseNumber,
        additionalInformation: this.$route.params.member.additionalInformation,
        salary: this.$route.params.member.salary,
        position: this.$route.params.member.position,
        //emergencyName:this.$route.params.member.emergencyName,
        //emergencyNumber:this.$route.params.member.emergencyNumber,
        contactNumber: this.$route.params.member.contactNumber,
        password: this.$route.params.member.password,
        confirmPassword: this.$route.params.member.password,

      },
      submit: false,
      submitted: false,
      formsubmit: false,
      typesubmit: false,

      calendarConfig: {
        wrap: true,
        dateFormat: 'd/m/Y',
      },
    }
  },
  validations: {
    form: {
      firstName: { required, minLength: minLength(2) },
      fatherName: { required, minLength: minLength(2) },
      grandFatherName: { required, minLength: minLength(2) },
      email: { required, email },
      zoneSubcity: { required },
      woreda: { required },
      kebele: { required },
      houseNumber: { required },
      salary: { required, minLength: minLength(3) },
      position: { required },
      //emergencyName: { required,  minLength: minLength(2) },
      //emergencyNumber: { required,  minLength: minLength(10), numeric },
      contactNumber: { required, minLength: minLength(10), numeric },
      password: { required, minLength: minLength(6) },
      confirmPassword: { required, sameAsPassword: sameAs('password') },
    },
    dobValue: { required },
  },
  methods: {
    /**
     * Basic Form submit
     */
    handleSubmit(e) {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.form.$pending || this.$v.form.$error || this.$v.$error) return
      this.updateMember()
    },

    async updateMember() {
      this.processingData = true
      try {
        const docRef = doc(firestore, 'member', this.$route.params.member.id)
        await updateDoc(docRef, {
          firstName: this.form.firstName,
          fatherName: this.form.fatherName,
          grandFatherName: this.form.grandFatherName,
          sex: this.sexValue,
          dob: this.dobValue,
          email: this.form.email,
          region: this.regionValue,
          zoneSubcity: this.form.zoneSubcity,
          woreda: this.form.woreda,
          kebele: this.form.kebele,
          houseNumber: this.form.houseNumber,
          additionalInformation: this.form.additionalInformation,
          employerId: this.employerValue,
          salary: this.form.salary,
          position: this.form.position,
          //emergencyName:this.form.emergencyName,
          //emergencyNumber:this.form.emergencyNumber,
          contactNumber: this.form.contactNumber,
          password: this.form.password,
          // created: serverTimestamp(),
          updated: serverTimestamp(),
          updatedBy: this.$store.state.auth.currentUser.id,
          dataComplete: true,
          accessLevel: this.accessLevelValue,
          status:this.statusValue,
          adminUnion:(this.accessLevelValue=='Union Administrator')?this.adminUnion:null,
          adminFederation:(this.accessLevelValue=='Federation Administrator')?this.adminFederation:null,
        })
        //this.makeToast(false, "Document written with ID: ", docRef.id);
        this.successStatus = true
        this.dismissSecs = 2
        this.alertMessage = this.$i18n.t('page.member.memberUpdatedMessage') + docRef.id
        this.showAlert()
        console.log('Document written with ID: ', docRef.id)
        await this.addToLog(
          'member modified',
          this.$store.state.auth.currentUser.id,
          docRef.id
        )
        setTimeout(() => {
              this.$router.push({ name: 'Member' })
            }, 2000)
        //this.clearFields();
      } catch (e) {
        console.error('Error updating document: ', e)
        this.successStatus = false
        this.dismissSecs = 4
        this.alertMessage = this.$i18n.t('page.member.unableToUpdate')
        this.showAlert()
        this.processingData = false
      }
      //this.processingData = false
    },

    // alert related methods
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },

    // encryption related methods
    encryptData(passwordData) {
      // return CryptoJS.AES.encrypt(JSON.stringify({ passwordData }), this.secret).toString();
      return CryptoJS.AES.encrypt(passwordData, this.secret).toString()
    },

    gotoMembers() {
      this.$router.push({ name: 'Member', params: { userId: '123' } })
    },

    dispatchActionFederation (actionName) {
      var index=this.federationsNameList.indexOf(actionName)
      this.adminFederation=this.federationsIdList[index]
      //console.log('>>>>>> Federation Name and ID: '+actionName+' | '+this.adminFederation)
    },

    dispatchActionUnion (actionName) {
      var index=this.unionsNameList.indexOf(actionName)
      this.adminUnion=this.unionsIdList[index]
      //console.log('>>>>>> Union Name and ID: '+actionName+' | '+this.adminUnion)
    },
    getStyle() {
      if (this.$i18n.locale == 'am') return 'lighterTextAm'
      else return 'lighterTextEn'
    },
  },
  async mounted() {
    //this.employerValue=this.employer[0];
    //this.sexValue=this.sex[0];
    //this.dobValue=Date.now();
    //this.regionValue=this.region[0];
    await axios
      .get('/api/gebi/employer/all')
      .then((response) => {
        for (let doc of response.data) this.employer.push(doc.name)
      })
    await axios
      .get('/api/gebi/region/all')
      .then((response) => {
        for (let doc of response.data) this.region.push(doc.name)
      })
    await axios
      .get('/api/gebi/access_level/all')
      .then((response) => {
        for (let doc of response.data) this.accessLevel.push(doc.name)
      })

    await axios
      .get('/api/gebi/member_status/all')
      .then((response) => {
        for (let doc of response.data) this.status.push(doc.name)
      })

      await axios
      .get('/api/gebi/federation/all')
      .then((response) => {
        for (let doc of response.data) 
        {
          this.federationsNameList.push(doc.name)
          this.federationsIdList.push(doc.id)
        }
      })
    await axios
      .get('/api/gebi/union/all')
      .then((response) => {
        for (let doc of response.data) 
        {
          this.unionsNameList.push(doc.name)
          this.unionsIdList.push(doc.id)
        }
      })

    if (!this.employer.includes(this.employerValue))
      this.employerValue = this.employer[0]
    if (!this.region.includes(this.regionValue))
      this.regionValue = this.region[0]

      if(this.adminFederation)
      {
        var index=this.federationsIdList.indexOf(this.adminFederation)
        this.adminFederationName=this.federationsNameList[index]
      }
      else{
        this.adminFederation=this.federationsIdList[0]
        this.adminFederationName=this.federationsNameList[0]
      }
      if(this.adminUnion)
      {
        var index=this.unionsIdList.indexOf(this.adminUnion)
        this.adminUnionName=this.unionsNameList[index]
      }
      else{
        this.adminUnion=this.unionsIdList[0]
        this.adminUnionName=this.unionsNameList[0]
      }
  }
}
</script>

<template>
  <Layout>
    <PageHeader  :title="$t('page.member.editTitle')" />
    <div class="row">
      <div class="col-lg-12">
        <b-alert
          v-if="successStatus"
          :show="dismissCountDown"
          dismissible
          fade
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <p>{{ alertMessage }}</p>
        </b-alert>
        <b-alert
          v-else
          :show="dismissCountDown"
          dismissible
          fade
          variant="danger"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <p>{{ alertMessage }}</p>
        </b-alert>
      </div>
    </div>
    
    
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('page.member.personalInfo')}}</h4>
            <p class="sub-header">{{$t('page.member.personalInfoDetails')}}</p>
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="firstName" :class="getStyle()">
                  {{$t('page.member.firstName')}}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="firstName"
                  v-model="form.firstName"
                  name="firstName"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.firstName.$error,
                  }"
                  type="text"
                />
                <div
                  v-if="submitted && $v.form.fatherName.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.fatherName.required"
                    >{{$t('page.member.errorValueRequired')}}</span
                  >
                  <span v-if="!$v.form.fatherName.minLength"
                    >{{$t('page.member.mustBeTwoLong')}}</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label for="fatherName" :class="getStyle()">
                  {{$t('page.member.fatherName')}}
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.fatherName"
                  type="text"
                  name="fatherName"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.fatherName.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.fatherName.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.fatherName.required"
                    >{{$t('page.member.errorValueRequired')}}</span
                  >
                  <span v-if="!$v.form.fatherName.minLength"
                    >{{$t('page.member.mustBeTwoLong')}}</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label for="grandFatherName" :class="getStyle()">
                  {{$t('page.member.grandFatherName')}}
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.grandFatherName"
                  type="text"
                  name="grandFatherName"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.grandFatherName.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.grandFatherName.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.grandFatherName.required"
                    >{{$t('page.member.errorValueRequired')}}</span
                  >
                  <span v-if="!$v.form.grandFatherName.minLength"
                    >{{$t('page.member.mustBeTwoLong')}}</span
                  >
                </div>
              </div>
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" :class="getStyle()">
                  {{$t('page.member.sex')}}</label>
                <multiselect v-model="sexValue" :options="sex"></multiselect>
              </div>

              <div class="form-group mb-3">
                <label :class="getStyle()"
                  >{{$t('page.member.dob')}}</label>
                <flat-pickr
                  v-model="dobValue"
                  :config="calendarConfig"
                  class="form-control"
                  name="dobValue"
                  :class="{
                    'is-invalid': submitted && $v.dobValue.$error,
                  }"
                ></flat-pickr>
                <div
                  v-if="submitted && !$v.dobValue.required"
                  class="invalid-feedback"
                  >{{$t('page.member.errorValueRequired')}}</div
                >
              </div>

              <div class="form-group">
                <label :class="getStyle()">
                  {{$t('page.member.email')}}
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.email"
                  type="text"
                  name="email"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.email.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.email.required"
                    >{{$t('page.member.errorValueRequired')}}</span
                  >
                  <span v-if="!$v.form.email.email"
                    >{{$t('page.member.validEmail')}}</span
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('page.member.address')}}</h4>
            <p class="sub-header">{{$t('page.member.enterAddress')}}</p>
            <form @submit.prevent="handleSubmit">
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" :class="getStyle()">{{$t('page.member.region')}}</label>
                <multiselect
                  v-model="regionValue"
                  :options="region"
                  :allow-empty="false"
                ></multiselect>
              </div>
              <div class="form-group">
                <label for="zoneSubcity" :class="getStyle()">
                  {{$t('page.member.zoneSubCity')}}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="zoneSubcity"
                  v-model="form.zoneSubcity"
                  name="zoneSubcity"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.zoneSubcity.$error,
                  }"
                  type="text"
                />
                <div
                  v-if="submitted && !$v.form.zoneSubcity.required"
                  class="invalid-feedback"
                  >{{$t('page.member.errorValueRequired')}}</div
                >
              </div>
              <div class="form-group">
                <label for="woreda" :class="getStyle()">
                  {{$t('page.member.woreda')}}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="woreda"
                  v-model="form.woreda"
                  name="woreda"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.woreda.$error }"
                  type="text"
                />
                <div
                  v-if="submitted && !$v.form.woreda.required"
                  class="invalid-feedback"
                  >{{$t('page.member.errorValueRequired')}}</div
                >
              </div>
              <div class="form-group">
                <label for="kebele" :class="getStyle()">
                  {{$t('page.member.kebele')}}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="kebele"
                  v-model="form.kebele"
                  name="kebele"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.kebele.$error }"
                  type="text"
                />
                <div
                  v-if="submitted && !$v.form.kebele.required"
                  class="invalid-feedback"
                  >{{$t('page.member.errorValueRequired')}}</div
                >
              </div>
              <div class="form-group">
                <label for="houseNumber" :class="getStyle()">
                  {{$t('page.member.houseNumber')}}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="houseNumber"
                  v-model="form.houseNumber"
                  name="houseNumber"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.houseNumber.$error,
                  }"
                  type="text"
                />
                <div
                  v-if="submitted && !$v.form.houseNumber.required"
                  class="invalid-feedback"
                  >{{$t('page.member.errorValueRequired')}}</div
                >
              </div>
              <div class="form-group">
                <label for="additionalInformation" :class="getStyle()">
                  {{$t('page.member.additionalInfo')}}
                </label>
                <input
                  id="additionalInformation"
                  v-model="form.additionalInformation"
                  name="additionalInformation"
                  class="form-control"
                  type="text"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('page.member.employer')}}</h4>
            <p class="sub-header">{{$t('page.member.employerinfo')}}</p>
            <form @submit.prevent="handleSubmit">
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" :class="getStyle()">
                  {{$t('page.member.employer')}}</label>
                <multiselect
                  v-model="employerValue"
                  :options="employer"
                  :allow-empty="false"
                ></multiselect>
              </div>
              <div class="form-group">
                <label :class="getStyle()">
                  {{$t('page.member.salary')}}
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.salary"
                  type="number"
                  name="salary"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.salary.$error }"
                />
                <div
                  v-if="submitted && $v.form.salary.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.salary.required"
                    >{{$t('page.member.errorValueRequired')}}</span
                  >
                  <span v-if="!$v.form.salary.numeric"
                    >{{$t('page.member.shouldBeMore')}}</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label for="position" :class="getStyle()">
                  {{$t('page.member.position')}}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="position"
                  v-model="form.position"
                  name="position"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.position.$error,
                  }"
                  type="text"
                />
                <div
                  v-if="submitted && !$v.form.position.required"
                  class="invalid-feedback"
                  >{{$t('page.member.errorValueRequired')}}</div
                >
              </div>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <div class="row">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('page.member.accountInfo')}}</h4>
            <p class="sub-header"
              >{{$t('page.member.enterAccountInfo')}}</p>
            <form @submit.prevent="handleSubmit">
              <!--div class="form-group">
                <label>
                  Phone number
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.contactNumber"
                  type="text"
                  name="contactTelephone"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.contactNumber.$error,
                  }"
                  placeholder="Enter phone number"
                />
                <div
                  v-if="submitted && $v.form.contactNumber.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.contactNumber.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.contactNumber.minLength"
                    >Phone number must be at least 10 characters.</span
                  >
                </div>
              </div-->

              <!--div class="form-group">
                <label>
                  Password
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.password"
                  type="password"
                  name="password"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.password.$error,
                  }"
                  placeholder="Enter password"
                />
                <div
                  v-if="submitted && $v.form.password.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.password.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.password.minLength"
                    >Password must be at least 6 characters.</span
                  >
                </div>
              </div-->

              <!--div class="form-group">
                <label>
                  Confirm Password
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.confirmPassword"
                  type="password"
                  name="confirmPassword"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.confirmPassword.$error,
                  }"
                  placeholder="Enter confirm password"
                />
                <div
                  v-if="submitted && $v.form.confirmPassword.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.confirmPassword.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.confirmPassword.minLength"
                    >Password must be at least 6 characters.</span
                  >
                  <span v-if="!$v.form.password.sameAsPassword"
                    >Both passwords must be the same.</span
                  >
                </div>
              </div-->

              <div class="form-group mt-3 mt-sm-0">
                  <label for="default" :class="getStyle()">
                  {{$t('page.member.accessLevel')}}</label>
                  <multiselect v-model="accessLevelValue" :options="accessLevel" :allow-empty="false"></multiselect>
              </div>

              <div v-if="accessLevelValue== 'Federation Administrator'" class="form-group mt-3 mt-sm-0">
                <label for="default" :class="getStyle()">
                  {{$t('page.member.chooseFederation')}}</label>
                <multiselect
                  v-model="adminFederationName"
                  :options="federationsNameList"
                  :allow-empty="false"
                  @select="dispatchActionFederation"
                ></multiselect>
              </div>

              <div v-if="accessLevelValue== 'Union Administrator'" class="form-group mt-3 mt-sm-0">
                <label for="default" :class="getStyle()">
                  {{$t('page.member.chooseUnion')}}</label>
                <multiselect
                  v-model="adminUnionName"
                  :options="unionsNameList"
                  :allow-empty="false"
                  @select="dispatchActionUnion"
                ></multiselect>
              </div>

              <div class="form-group mt-3 mt-sm-0">
                  <label for="default" :class="getStyle()">
                  {{$t('page.member.status')}}</label>
                  <multiselect v-model="statusValue" :options="status" :allow-empty="false"></multiselect>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!--form @submit.prevent="handleSubmit">
                  <button v-if='!processingData' type="submit" class="btn btn-primary"
                    >Save</button>
                  <button v-else disabled  class="btn btn-primary"
                  >Save</button>
                  <a href="/member">
                  <button class="btn btn-secondary m-l-5 ml-1"
                    >Cancel</button></a>
            </form-->
            <form @submit.prevent="handleSubmit">
              <template>
                <b-button :disabled="processingData" type="submit" variant="primary"
                  ><i class="uil uil-down-arrow mr-1"></i>{{$t('page.member.updateMember')}}</b-button
                >
                <b-button
                  variant="light"
                  @click="gotoMembers"
                  style="margin-left: 10px"
                  >{{$t('page.member.close')}}</b-button
                >
              </template>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.btn {
  font-size: 1rem;
}
.lighterTextAm {
  font-weight: 500 !important;
  font-size: 1rem !important;
}
.lighterTextEn {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}
</style>
